// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    assignfee
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset();
  today.setMinutes(today.getMinutes() - offset);
  return today.toISOString().split("T")[0];
};
const initialState = {
  assignfee: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
};


// Async Thunks for API Calls
export const  createAssignFee = createAsyncThunk(
  "assignfee/createAssignFee",
  async (
    {data,school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await assignfee(data,
        school_id, token, signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

 
// Class Slice
const assignFeeSlice = createSlice({
  name: "assignfee",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        date,
        student,
        exam
      } = action.payload;
      state.formData = {
        id,
        date,
        student,
        exam
      };
    },
    resetFormData(state) {
      state.formData = {
        date:getTodayDate()||"",
        student: "",
        exam : ""
      };
    },
    setadmitcard(state, action) {
      state.admitcards = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAssignFee.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createAssignFee.fulfilled, (state, action) => {
        state.addLoading = false;
        state.assignfee = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createAssignFee.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
  },
});

// Export the actions and the reducer
export const {
  setadmitcard,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = assignFeeSlice.actions;
export default assignFeeSlice.reducer;
